import React from "react";
import { Box, Stack, Skeleton } from "@mui/material";

export default function EvaluationSkeleton({ count = 4 }) {
  return (
    <Stack spacing={1.5}>
      <Skeleton variant="rounded" height={88} sx={{ borderRadius: "14px" }} />
      {[0, 1, 2, 3].map((i) => (
        <Skeleton key={i} variant="rounded" height={48} sx={{ borderRadius: "12px" }} />
      ))}
      <Stack spacing={1.5} sx={{ mt: 1 }}>
        {Array.from({ length: count }).map((_, i) => (
          <Skeleton key={i} variant="rounded" height={180} sx={{ borderRadius: "14px" }} />
        ))}
      </Stack>
    </Stack>
  );
}

export function EmptyState({ message }) {
  return (
    <Box
      sx={{
        py: 8,
        px: 3,
        textAlign: "center",
        color: "#9ca3af",
        fontSize: "0.9rem",
      }}
    >
      {message}
    </Box>
  );
}
